export default "__VITE_ASSET__DvE5POTd__"